import { Search } from "lucide-react";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import MultiSelect from "./MultiSelect";
import SingleSelect from "./SingleSelect";
import DateRangePicker from "./DateRangePicker";
import { Icons } from "assets/icons";

const FilterBar = ({
  keyword,
  setKeyword,
  keywordPlaceholder = "Search",
  selectedFilters = {},
  setSelectedFilters = () => {},
  dates = [],
  setDates = () => {},
  filters = [],
  onSearch = () => {},
  onReset = () => {},
  className = "",
  isDateRange = true,
  isBtn = false,
  btnText = "",
  onBtnClick = () => {},
  onFilterUpdate = () => {},
  searchMaxWidth = 300,
  rightActions = null,
}) => {
  const { t } = useTranslation();

  const { refresh, lightSearch, plus } = Icons || {};

  const handleFilterChange = (key, value) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
    onFilterUpdate(key, value);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setKeyword(value);

    // Call handleSearch when input becomes empty
    if (value.trim() === "") {
      setTimeout(() => {
        onSearch(null, { actionType: "RESET_KEYWORD" });
      }, 100);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch(1, { actionType: "SEARCH" });
    }
  };

  const handleReset = () => {
    onReset();
  };

  return (
    <Row className={`common_filter ${className}`}>
      <Col className="filter_search_col" style={{ maxWidth: searchMaxWidth }}>
        <div className="search_input">
          <input
            type="text"
            placeholder={t(keywordPlaceholder)}
            value={keyword}
            onChange={handleSearchChange}
            onKeyDown={handleKeyDown}
            title={keywordPlaceholder}
          />
          <img
            src={lightSearch}
            width={20}
            height={20}
            alt="search"
            className="search_icon"
          />
        </div>
      </Col>
      <Col>
        <div className="g_end flex-wrap gap-3 mt-2  mt-lg-0">
          {filters.map((filter) => {
            return filter.type === "multiSelect" ? (
              <MultiSelect
                key={filter.key}
                value={selectedFilters[filter.key] || []}
                options={filter.options}
                placeholder={filter.placeholder || t("Select Options")}
                onChange={(val) => handleFilterChange(filter.key, val)}
                hideError={true}
              />
            ) : filter.type === "singleSelect" ? (
              <SingleSelect
                key={filter.key}
                value={selectedFilters[filter.key]}
                handleSingleSelectChange={(e) =>
                  handleFilterChange(filter.key, e.value)
                }
                options={filter.options}
                optionLabel="name"
                placeholder={filter.placeholder}
                className="custom_dropdown"
                hideError={true}
              />
            ) : (
              ""
            );
          })}

          {isDateRange && <DateRangePicker dates={dates} setDates={setDates} />}
          
          {rightActions && (
            <div className="custom-actions g_center gap-2 ms-2">
              {rightActions}
            </div>
          )}

          <div className="buttons">
            <button
              type="button"
              className="search_btn"
              onClick={() => onSearch(1, { actionType: "SEARCH" })}
            >
              <Search size={20} />
            </button>
            <button className="reset_btn" type="button" onClick={handleReset}>
              <img src={refresh} width={20} height={20} alt="search" />
            </button>
          </div>

          {isBtn && (
            <button
              type="button"
              className="main_btn g_center gap-1"
              onClick={onBtnClick}
            >
              <img src={plus} alt="" width={20} height={20} />
              {btnText}
            </button>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default FilterBar;
